var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.402 17.763H5.535c-.459 0-.918-.229-1.204-.573a1.417 1.417 0 0 1-.287-1.262L6.51 5.147C6.682 4.459 7.255 4 8 4h4.933c1.319 0 2.523.573 3.383 1.606.803 1.032 1.147 2.351.86 3.67-.458 2.294-2.523 3.9-4.874 3.9h-1.835a.672.672 0 0 0-.63.516l-.861 3.613a.558.558 0 0 1-.574.458Z",
    fill: "#253B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.402 17.763H5.535c-.459 0-.918-.229-1.204-.573a1.417 1.417 0 0 1-.287-1.262L6.51 5.147C6.682 4.459 7.255 4 8 4h4.933c1.319 0 2.523.573 3.383 1.606.803 1.032 1.147 2.351.86 3.67-.458 2.294-2.523 3.9-4.874 3.9h-1.835a.672.672 0 0 0-.63.516l-.861 3.613a.558.558 0 0 1-.574.458Z",
    fill: "#253B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.324 9.333v.172c-.574 2.81-3.097 4.818-5.964 4.818h-1.434l-.803 3.268c-.23.803-.917 1.32-1.72 1.32H7.256c.057.229.115.4.287.573.286.344.688.516 1.147.516h2.58c.287 0 .516-.172.574-.401l.803-3.155c.057-.229.286-.344.516-.344h1.663c2.122 0 4.014-1.433 4.415-3.44.23-1.205-.114-2.466-.917-3.327Z",
    fill: "#2997D8"
  }))));
};
export default SvgPaypal;